import { Link, useNavigate } from 'react-router-dom';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import { AppCard } from '../../components/ui/AppCard';
import { reopenCookieBanner } from '../../components/CookieConsentBanner';

// Public, unauthenticated route (see App.tsx, alongside /terms /privacy
// /cookies) - just a links hub, not a document itself, so it deliberately
// doesn't use LegalLayout (its "Last updated" line only makes sense on an
// actual legal document). Reached from AppLayout's sidebar "Legal" link
// (moved out of SettingsScreen, which used to have this same row group
// inline) as well as directly by anyone with the URL, logged in or not -
// same reasoning TermsScreen's header comment already gives for why
// these pages stay outside RequireGuest/RequireAuth.
function Row({ to, title, onClick }: { to?: string; title: string; onClick?: () => void }) {
  const content = (
    <AppCard className="flex items-center gap-3">
      <span className="flex-1 text-[15px] font-medium">{title}</span>
      <ChevronRight size={18} className="text-black/30 dark:text-white/30" />
    </AppCard>
  );
  if (onClick) {
    return (
      <button type="button" onClick={onClick} className="text-left w-full">
        {content}
      </button>
    );
  }
  return <Link to={to!}>{content}</Link>;
}

export function LegalScreen() {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen w-full bg-[var(--color-bg)]">
      <header className="flex items-center gap-3 px-4 sm:px-6 py-4 max-w-2xl mx-auto">
        <Link to="/" className="flex items-center gap-2 shrink-0">
          <img src="/zmist-logo.svg" alt="Zmist" className="w-8 h-8" />
          <span className="text-[15px] font-semibold">Zmist</span>
        </Link>
        <button
          onClick={() => navigate(-1)}
          className="ml-auto flex items-center gap-1 text-[14px] text-black/50 dark:text-white/50 hover:text-black/80 dark:hover:text-white/80"
        >
          <ChevronLeft size={16} /> Back
        </button>
      </header>
      <main className="max-w-2xl mx-auto px-4 sm:px-6 flex flex-col gap-4 pb-16 md:pb-20">
        <h1 className="text-3xl font-bold tracking-tight mt-2 mb-2">Legal</h1>
        <Row to="/terms" title="Terms of Service" />
        <Row to="/privacy" title="Privacy Policy" />
        <Row to="/cookies" title="Cookie Policy" />
        <Row to="/subprocessors" title="Sub-processors" />
        <Row to="/dpa" title="Data Processing Addendum" />
        <Row title="Cookie settings" onClick={reopenCookieBanner} />
      </main>
    </div>
  );
}
